import { render, staticRenderFns } from "./findlawtip.vue?vue&type=template&id=19cf55b8&"
import script from "./findlawtip.vue?vue&type=script&lang=js&"
export * from "./findlawtip.vue?vue&type=script&lang=js&"
import style0 from "./findlawtip.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports